import type { OrganizationSettings, OrganizationSettingsRequest } from "@shyne/shared/api";
import { OrganizationRepository } from "@/repositories/organization.repository.ts";

export async function getCurrentOrganization(): Promise<OrganizationSettings> {
    return OrganizationRepository.getCurrentOrganization();
}

export async function updateCurrentOrganization(settings: OrganizationSettingsRequest): Promise<OrganizationSettings> {
    return OrganizationRepository.update(settings);
}

export async function uploadOrganizationImage(file: File): Promise<OrganizationSettings> {
    return OrganizationRepository.uploadImage(file);
}
